module.exports = __webpack_public_path__ + "img/7.bf7ebf87.jpg";